import { createSlice } from "@reduxjs/toolkit";

const initialState={
    isDictionaryModalOpen:false,
    dictionaryWord:"",
    dictionaryMeaning:[],
}

const dictionarySlice=createSlice({
    name:"dictionary",
    initialState,
    reducers:{
        setDictionaryModalOpened(state){
            state.isDictionaryModalOpen=!state.isDictionaryModalOpen;
        },
        setDictionaryWord(state,action){
            state.dictionaryWord=action.payload;
        },
        setDictionaryMeaning(state,action){
            state.dictionaryMeaning=action.payload;
        },
    },
});

export const {setDictionaryModalOpened,setDictionaryWord,setDictionaryMeaning}=dictionarySlice.actions;
export const selectIsDictionaryModalOpen= (state) => state.dictionary.isDictionaryModalOpen;
export const selectDictionaryWord= (state) => state.dictionary.dictionaryWord;
export const selectDictionaryMeaning= (state) => state.dictionary.dictionaryMeaning;
export default dictionarySlice.reducer;
